module.exports = __webpack_public_path__ + "media/src/images/partners/gesis-573caabc5bceb87e18f868874865891b.jpg";